/**
 * This module is used to switch the product grid image view.
 */

export default class Views {
	constructor(query) {
		var viewSwitchers = document.querySelectorAll(query);

		// assign handlers to each switcher
		[].forEach.call(viewSwitchers, this.setHandler.bind(this));
	}

	setHandler(viewSwitcher) {
		let viewProps = JSON.parse(viewSwitcher.getAttribute('data-view-props'));

		$(viewSwitcher).on('click', function(event) {
			Views.switchView(event, viewProps);
		});
	}

	/**
	 * Sswitches the target container's data-view to the passed type.
	 * @param  {[Object]} viewProps: .type: [string], .target: [String selector]
	 */
	static switchView(event, viewProps) {
		var viewContainer = document.querySelector(viewProps.target);

		viewContainer.setAttribute('data-view', viewProps.type);

		Views.updateSlick(viewContainer, viewProps.type);

		$.ajax({
			type: 'post',
			url: $(event.target).data('url'),
			dataType: 'json',
			data: {
				'prop' : viewProps.type
			}
		});

		return false;
	}

	/**
	 * Updates the tile slick items (if any) to the target view type: model-view or product-view.
	 * @param  {[Node]} viewContainer [target container from which the slick items should be selected]
	 * @param  {[String]} viewType      [target view type]
	 */
	static updateSlick(viewContainer, viewType) {
		var tileSliders = viewContainer.querySelectorAll('.product__images.slick-slider');

		[].forEach.call(tileSliders, function(tile) {
			var $tile = $(tile),
				targetIndex = Views.getIndex($tile, viewType);

			$tile.slick('slickGoTo', targetIndex, true);
		});
	}

	static getIndex($tile, viewType) {

		viewType = viewType || $tile.closest('[data-view]').attr('data-view');

		return viewType === 'model-view' ? 1 : 0;
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.views.js